import {
  useMetricsStats,
  useMetricsTrends,
  useMetricsPatterns,
} from "../../../../../shared/hooks";
import type {
  MetricsStatsParams,
  MetricsTrendsParams,
  MetricsPatternsParams,
} from "../../../../../shared/api/types";

export const useBiometricsStats = (params?: MetricsStatsParams) => {
  return useMetricsStats({
    ...params,
    metrics: params?.metrics || [
      "respiratory_rate",
      "spo2",
      "pace_of_aging",
      "temperature",
      "resting_heart_rate",
      "hrv",
    ],
  });
};

export const useBiometricsTrends = (params?: MetricsTrendsParams) => {
  return useMetricsTrends({
    ...params,
    metrics: params?.metrics || [
      "avg_heart_rate",
      "max_heart_rate",
      "respiratory_rate",
      "spo2",
      "hrv",
      "resting_heart_rate",
    ],
    granularity: params?.granularity || "daily",
  });
};

export const useBiometricsPatterns = (params: MetricsPatternsParams) => {
  return useMetricsPatterns({
    ...params,
    // The generic hook takes one metric
  });
};
